import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { infoStatus } from '../../helpers/camerasStatus';

// A imagem do mapa ajustada a area disponivel, sem distorcer, com uma camada
// por cima do MESMO tamanho da imagem: os marcadores usam x/y em % dela, entao
// caem no lugar certo em qualquer tamanho de tela.
//
// O `ref` aponta para essa camada (o editor mede ela para arrastar).
const MapaPlano = forwardRef(function MapaPlano({ url, onClickPlano, children }, ref) {
  const areaRef = useRef(null);
  const [natural, setNatural] = useState(null); // { w, h } da imagem
  const [area, setArea] = useState({ w: 0, h: 0 });
  const [falhou, setFalhou] = useState(false);

  useEffect(() => {
    const el = areaRef.current;
    if (!el) return undefined;
    const medir = () => setArea({ w: el.clientWidth, h: el.clientHeight });
    medir();
    const ro = new ResizeObserver(medir);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  useEffect(() => { setNatural(null); setFalhou(false); }, [url]);

  let caixa = null;
  if (natural && area.w && area.h) {
    const escala = Math.min(area.w / natural.w, area.h / natural.h);
    const w = natural.w * escala;
    const h = natural.h * escala;
    caixa = { width: w, height: h, left: (area.w - w) / 2, top: (area.h - h) / 2 };
  }

  const clicar = (e) => {
    if (!onClickPlano || e.target !== e.currentTarget) return;
    const r = e.currentTarget.getBoundingClientRect();
    onClickPlano(((e.clientX - r.left) / r.width) * 100, ((e.clientY - r.top) / r.height) * 100);
  };

  return (
    <div className="mapa-plano" ref={areaRef}>
      {falhou ? (
        <div className="cameras-vazio">
          <i className="bi bi-image" style={{ fontSize: 34, opacity: 0.5 }} />
          <span>Não foi possível carregar a imagem do mapa.</span>
        </div>
      ) : null}
      <img
        src={url}
        alt=""
        className="mapa-plano__imagem"
        style={caixa || { visibility: 'hidden' }}
        onLoad={(e) => setNatural({ w: e.currentTarget.naturalWidth, h: e.currentTarget.naturalHeight })}
        onError={() => setFalhou(true)}
        draggable={false}
      />
      {caixa ? (
        <div
          ref={ref}
          className={`mapa-plano__camada ${onClickPlano ? 'mapa-plano__camada--clicavel' : ''}`}
          style={caixa}
          onClick={clicar}
          role="presentation"
        >
          {children}
        </div>
      ) : null}
    </div>
  );
});

export default MapaPlano;

// Icone de uma camera no mapa: bolinha com a cor do status e, se a camera
// tiver direcao, um cone mostrando para onde ela aponta.
export function MarcadorCamera({
  item, nome, status, selecionado, mostrarNome, titulo, onClick, onPointerDown,
}) {
  const info = infoStatus(status);
  const alerta = status === 'sem_video' || status === 'offline';
  return (
    <div
      className={[
        'mapa-marcador',
        selecionado ? 'mapa-marcador--selecionado' : '',
        alerta ? 'mapa-marcador--alerta' : '',
      ].join(' ')}
      style={{ left: `${item.x}%`, top: `${item.y}%`, '--cor-status': info.cor }}
    >
      {item.direcao !== null && item.direcao !== undefined ? (
        <span className="mapa-marcador__cone" style={{ transform: `rotate(${item.direcao}deg)` }} />
      ) : null}
      <button
        type="button"
        className="mapa-marcador__ponto"
        title={titulo || `${nome} — ${info.rotulo}`}
        aria-label={`${nome}: ${info.rotulo}`}
        onClick={onClick}
        onPointerDown={onPointerDown}
      >
        <i className="bi bi-camera-video-fill" />
      </button>
      {mostrarNome || alerta || selecionado ? <span className="mapa-marcador__nome">{nome}</span> : null}
    </div>
  );
}
